import React, {FC} from 'react';
import './style.scss';
import Header from "../Header";
import editPreferences from "../../assets/img/header/edit__preferences.svg";

interface IMainHeader {
    editHandler: () => void
}

const MainHeader: FC<IMainHeader> = ({editHandler}) => {
    return (
        <Header>
            <div className="main-header__container">
                <img
                    onClick={editHandler}
                    className="main-header__image"
                    src={editPreferences}
                    alt="edit Preferences"
                />
                <div className="main-header__text-cont">
                    <span className="header__standard-text">
                        Главная
                    </span>
                </div>
            </div>
        </Header>
    )
};

export default MainHeader;
